import {
	Alert,
	Box,
	Breadcrumbs,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	SelectChangeEvent,
	Stack,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import {
	DataGridPremium,
	GridColDef,
	GridColumnVisibilityModel,
	GridDensity,
	GridRenderEditCellParams,
	GridSelectionModel,
	koKR,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import { getSettings } from 'helpers/storage'
import { selectCmmnCode } from 'hooks/cmmnCodeFactory'
import { selectuserInfo } from 'hooks/userInfo'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import moment from 'moment'
import {
	alertModal,
	isValidDateType,
	compareDate,
	hexToRgba,
	confirmAlert,
	timerAlert,
} from 'util/util'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {
	apiReportTypeList,
	apiRptCodeListByReportCode,
	httpGet,
	httpPost,
} from 'api/api'
import { PageBg } from 'components/ComponentStyles'
import React from 'react'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import SmsIcon from '@mui/icons-material/Sms'
import { valuesInIterator } from 'util/objectUtil'

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

const SearchRowItem = styled(Box)(({ theme }) => ({
	position: 'relative',
	display: 'block',
	paddingLeft: '80px',
	minHeight: '44px',
	marginBottom: '10px',
	'&.noLabel': {
		paddingLeft: '0',
	},
	'.labelText': {
		position: 'absolute',
		left: '10px',
		top: '15px',
		[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
			position: 'relative',
			left: '0',
			top: '0',
			marginBottom: '0.5rem',
		},
	},
	[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
		paddingLeft: '0',
		height: 'auto',
	},
}))

const locales = ['ko'] as const

type SearchType = {
	clientID: string // 거래처id
	startDate: string // 시작일자
	endDate: string // 종료일자
	resultType: 'N' | 'A' | 'P' // N: 음성, P: 양성, A: 전체
	phoneNumberExist: '0' | '1' | '2' // 휴대폰번호 존재 여부 0: 전체, 1: 존재, 2: 미존재
	patientName: string // 수진자명
	chartNo: string // 차트번호
}

const initialSearch: SearchType = {
	clientID: '',
	startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
	endDate: moment().format('YYYY-MM-DD'),
	resultType: 'N',
	phoneNumberExist: '2',
	patientName: '',
	chartNo: '',
}

type PartCodeType = {
	partName: string
	partCode: string
}

type RptCodeType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: string
	active: boolean
}

type ListType = {
	RowNum: number
	ReceptionID: number
	FinalMessage: string
	NegCount: number
	PosCount: number
	ParentCode: string
	PatientName: string
	RptTypeCode: string
	TemplateID: number
	ReceptionDate: string
	CellNumber: string
	TemplateName: string
	ChartNo: string
	IsSent: boolean
	ReceptionRegNum: string
}

const columns: GridColDef[] = [
	{
		field: 'RowNum',
		headerName: 'No.',
		width: 60,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ReceptionID',
		headerName: '접수ID',
		width: 100,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ReceptionDate',
		headerName: '접수일자',
		width: 150,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ReceptionRegNum',
		headerName: '접수번호',
		width: 150,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'PatientName',
		headerName: '수진자명',
		width: 200,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ChartNo',
		headerName: '차트번호',
		width: 100,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'CellNumber',
		headerName: '휴대폰번호',
		width: 150,
		headerAlign: 'center',
		align: 'center',
		editable: true,
	},
	{
		field: 'FinalMessage',
		headerName: '전송메시지',
		width: 300,
		headerAlign: 'center',
		align: 'left',
		editable: true,
		renderEditCell: (params: GridRenderEditCellParams) => {
			const editValue = String(params.value ?? '').replace(/\\n/g, '\n')
			return (
				<TextField
					fullWidth
					multiline
					minRows={3}
					size="small"
					value={editValue}
					onChange={(event) => {
						params.api.setEditCellValue({
							id: params.id,
							field: params.field,
							value: event.target.value,
						})
					}}
					onKeyDown={(event) => {
						event.stopPropagation()
					}}
				/>
			)
		},
		renderCell: (params) => {
			const message = String(params.value ?? '').replace(/\\n/g, '\n')
			return (
				<Box
					sx={{
						whiteSpace: 'pre-wrap',
						wordBreak: 'break-word',
						lineHeight: 1.4,
						py: 1,
					}}
				>
					{message}
				</Box>
			)
		},
	},
	{
		field: 'IsSent',
		headerName: '전송여부',
		width: 100,
		headerAlign: 'center',
		align: 'center',
		renderCell: (params) => {
			return params.value === 1 ? '전송' : '미전송'
		},
	},
]

const AutoSmsIndivisual = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

	const grid1Ref = useGridApiRef()

	const [gridIsLoading, setGridIsLoading] = useState<boolean>(false)

	const userInfo = useSelector(selectuserInfo)
	const env = getSettings()
	// ui
	const cmmnCdList = useSelector(selectCmmnCode)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const disabledReset = false

	const [dateRange, setDateRange] = useState('1d')
	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])
	const [size, setSize] = useState(env.row ? env.row : 100)
	const [page, setPage] = useState(0)

	const [search, setSearch] = useState<SearchType>(initialSearch)
	// 보고서 종류 코드 목록
	const [rptTypeList, setRptTypeList] = useState<RptCodeType[]>([])
	// 조회조건 (검체종류)
	const [testCdList, setTestCdList] = useState<any>([])
	const [list, setList] = useState<ListType[]>([])

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const actionSearch = () => {
		console.table(search)
		setGridIsLoading(true)
		httpGet('autoSms/client/messageTarget/list', search)
			.then((res) => {
				console.log(res)
				// 전화번호가 없는 데이터만 출력
				res = res.filter((item: any) => {
					// return String(item.CellNumber ?? '').trim() === '' || item.IsSent === 0
					return item.IsSent === 0
				})
				console.log(res)
				setList(res)
			})
			.finally(() => {
				setGridIsLoading(false)
			})
	}

	const actionReset = () => {}

	// calcaulate today before n days
	const getBeforeDate = (n: number) => {
		setSearch({
			...search,
			startDate: moment(search.endDate).subtract(n, 'days').format('YYYY-MM-DD'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1d':
				getBeforeDate(1)
				break
			case '3d':
				getBeforeDate(3)
				break
			case '7d':
				getBeforeDate(7)
				break
			case '14d':
				getBeforeDate(14)
				break
			default:
				getBeforeDate(7)
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event

	const dateRanageOnChange = (e: any, target: string) => {
		// setIsDateRangeChanged(false)
		if (moment(new Date(e)).isBefore('2023-08-01')) {
			alertModal('2023-08-01 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				[target]: moment(new Date(e)).format('yyyy-MM-DD'),
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM-DD').length === 10) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...prevState,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue < -1825) {
						alertModal('검색기간은 5년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...prevState,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue > 1825) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...prevState,
						[target]: moment(new Date(e)).format('yyyy-MM-DD'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		console.log(e)
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	/**
	 * 검체종류 select
	 * @param e
	 */
	const searchTestCdOnChange = (e: SelectChangeEvent<string>): void => {
		const selectedPartCode = e.target.value

		apiRptCodeListByReportCode(selectedPartCode).then((res) => {
			console.log(res)
			setRptTypeList(res)

			setSearch((prev) => ({
				...prev,
				partCode: selectedPartCode,
				reportTypeCode: res?.[0]?.rptTypeCode ?? '0',
			}))
		})
	}

	const [columnVisibilityModel, setColumnVisibilityModel] =
		React.useState<GridColumnVisibilityModel>({
			ReceptionID: false,
			RowNum: false,
			ReceptionDate: true,
			ReceptionInfo: true,
			PatientName: true,
			ChartNo: true,
			ClientInfo: true,
			DepartName: true,
			PartName: true,
			RptTypeName:
				userInfo.clientID === 6499 ||
				userInfo.clientID === 6502 ||
				userInfo.infoType === 'S' ||
				userInfo.infoType === 'W'
					? true
					: false,
			FindingsCnt: false,
			StateCategory: true,
			Decision: true,
			isView: true,
		})

	// sms 전송
	const smsAction = () => {
		const row = valuesInIterator(grid1Ref.current?.getSelectedRows())
		if (row.length > 0) {
			confirmAlert(
				'선택한 수진자에게 SMS를 전송하시겠습니까?',
				() => {
					const jsonArr: any[] = []

					row.forEach((item: any) => {
						jsonArr.push({
							Subject: item.TemplateName,
							// DestInfo: item.PatientName + '^' + item.CellNumber,
							DestInfo: item.PatientName + '^' + '01029523416', // 임시
							MmsMsg: item.FinalMessage,
							ScheduleType: '0',
							ChartNo: item.ChartNo,
							ReceptionID: item.ReceptionID,
							RptTypeCode: item.RptTypeCode,
							ResultType: item.ResultType ? item.ResultType : 'X',
							TemplateID: item.TemplateID,
							ClientID:
								userInfo.infoType === 'C' ? userInfo.clientID : search.clientID,
							RowCrud: 'C',
						})
					})

					const json = {
						clientID: userInfo.infoType === 'C' ? userInfo.clientID : search.clientID,
						json: jsonArr,
					}

					alertModal('문자 전송 중입니다.', 'info', () => {})

					console.log(json)
					httpPost('autoSms/client/smsSend', json).then((res) => {
						console.log(res)
						timerAlert('문자 전송 완료', 'success', () => {}, 3000)
						actionSearch()
					})
				},
				() => {},
			)
		} else {
			alertModal('SMS를 전송할 수진자를 선택해주세요.', 'warning', () => {})
			return
		}
	}

	useEffect(() => {
		console.log(userInfo)
		console.log(userInfo.infoType === 'W' || userInfo.infoType === 'S')
		// 사용자 타입이 거래처일 경우만 자동 조회
		if (userInfo.infoType === 'C') actionSearch()

		apiReportTypeList().then((res) => {
			console.log(res)
			setTestCdList(res)
		})

		apiRptCodeListByReportCode('0').then((res) => {
			console.log(res)
			setRptTypeList(res)
		})
	}, [])

	// 전송 메시지 파트
	const [selectedPatientInfo, setSelectedPatientInfo] = useState({})
	const [concatenatedMessage, setConcatenatedMessage] = useState('')
	const messageInputRef = React.useRef<HTMLTextAreaElement | null>(null)
	const messageCursorRef = React.useRef(0)

	const updateMessageCursor = (
		target: HTMLInputElement | HTMLTextAreaElement | null,
	) => {
		if (!target) return
		messageCursorRef.current = target.selectionStart ?? target.value.length
	}

	const getSafeInsertPosition = (text: string, cursorPosition: number) => {
		const openBraceIndex = text.lastIndexOf('{', cursorPosition)
		const closeBraceIndex = text.indexOf('}', cursorPosition)

		// 이미 { ... } 내부에 커서가 있으면 닫는 괄호 뒤로 이동해 중첩을 방지
		if (
			openBraceIndex !== -1 &&
			closeBraceIndex !== -1 &&
			openBraceIndex < cursorPosition &&
			cursorPosition <= closeBraceIndex
		) {
			return closeBraceIndex + 1
		}

		return cursorPosition
	}

	const insertMessageVariable = (variableName: string) => {
		// 동일 변수는 중복 삽입하지 않음
		if (concatenatedMessage.includes(variableName)) {
			return
		}

		const cursorPosition = getSafeInsertPosition(
			concatenatedMessage,
			messageCursorRef.current,
		)

		const newMessage =
			concatenatedMessage.slice(0, cursorPosition) +
			variableName +
			concatenatedMessage.slice(cursorPosition)

		setConcatenatedMessage(newMessage)
		messageCursorRef.current = cursorPosition + variableName.length

		requestAnimationFrame(() => {
			if (messageInputRef.current) {
				messageInputRef.current.focus()
				messageInputRef.current.setSelectionRange(
					messageCursorRef.current,
					messageCursorRef.current,
				)
			}
		})
	}

	const messageVariableList = [
		{
			id: 1,
			name: '{수진자명}',
		},
		{
			id: 2,
			name: '{검사명}',
		},
		{
			id: 3,
			name: '{결과}',
		},
	]

	// sms 전송 버튼 활성화 조건
	const smsSendCondition = () => {
		const cellPhonePattern = /^(010|011|016|107|109)\d{8}$/
		const selectedIdSet = new Set(selectionModel.map((id) => String(id)))
		const selectedRows = list.filter((row) =>
			selectedIdSet.has(String(row.RowNum)),
		)

		if (selectedRows.length === 0) {
			return false
		}

		// 선택된 모든 행에 필수 값이 있어야 전송 가능
		return selectedRows.every(
			(item) =>
				String(item?.PatientName ?? '').trim() !== '' &&
				cellPhonePattern.test(String(item?.CellNumber ?? '').trim()) &&
				String(item?.FinalMessage ?? '').trim() !== '',
		)
	}

	const handleCellEditCommit = (params: any) => {
		const editableFields = ['CellNumber', 'FinalMessage']
		if (!editableFields.includes(params.field)) {
			return
		}

		let nextValue = params.value ?? ''

		if (params.field === 'CellNumber') {
			nextValue = String(nextValue).replace(/\D/g, '')
			if (nextValue !== '' && !/^(010|011|016|107|109)\d{8}$/.test(nextValue)) {
				alertModal(
					'휴대폰번호는 하이픈 없이 010, 011, 016, 107, 109로 시작하는 11자리 숫자만 입력 가능합니다.',
					'warning',
					() => {},
				)
			}
		}

		setList((prev) =>
			prev.map((row) =>
				String(row.RowNum) === String(params.id)
					? { ...row, [params.field]: nextValue }
					: row,
			),
		)
	}

	const isCellEditable = (params: any) => {
		if (params.field === 'CellNumber') {
			return String(params.row?.CellNumber ?? '').trim() === ''
		}

		if (params.field === 'FinalMessage') {
			return true
		}

		return false
	}

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								개별 문자 발송
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										color="primary"
										variant="contained"
										startIcon={<ContentPasteSearchTwoToneIcon />}
										onClick={actionSearch}
										size="small"
										disabled={disabledSearch}
										sx={{ marginRight: '0.5rem' }}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										color="secondary"
										variant="contained"
										startIcon={<SmsIcon />}
										sx={{ marginRight: '0.5rem' }}
										onClick={smsAction}
										size="small"
										disabled={!smsSendCondition()}
									>
										SMS 전송
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="시작일"
										value={search.startDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="종료일"
										value={search.endDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="차트번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.chartNo}
										onChange={(e) => {
											setSearch({
												...search,
												chartNo: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.patientName}
										onChange={(e) => {
											setSearch({
												...search,
												patientName: e.target.value,
											})
										}}
									/>
								</Grid>
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={2}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControlLabel
										control={
											<Checkbox
												checked={search.phoneNumberExist === '0'}
												onChange={(e) =>
													setSearch({
														...search,
														phoneNumberExist: e.target.checked ? '0' : '2',
													})
												}
											/>
										}
										label="전체 리스트"
									/>
								</Grid>
							</Grid>
							<Grid
								container
								spacing={1}
							>
								<Grid item>
									<Alert
										severity="info"
										sx={{ fontSize: '13px', mt: 1 }}
									>
										전송하고자 하는 수진자의 휴대폰 번호 및 전송 메시지를 더블 클릭해서
										작성 후 sms 전송이 가능합니다.
									</Alert>
								</Grid>
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				id="back-to-top"
				elevation={0}
				sx={{
					width: '100%',
					// overflow: 'hidden',
					backgroundColor: 'transparent',
					// overflow: 'auto',
				}}
			>
				<Grid
					container
					spacing={2}
				>
					<Grid
						item
						xs={12}
					>
						<PageBg style={{ marginTop: '1rem' }}>
							<Typography
								variant="subtitle1"
								component="h3"
								sx={{ lineHeight: '1rem' }}
							>
								수진자 리스트
							</Typography>
							<Box
								sx={{
									marginTop: '1rem',
									height: 813,
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<DataGridPremium
									apiRef={grid1Ref}
									page={page}
									onPageChange={(newPage) => setPage(newPage)}
									rows={list}
									getRowId={(row) => row.RowNum}
									columns={columns}
									// getRowClassName={(params) =>
									// 	params.row.StateCategory !== '완료' ? 'no-image-row' : ''
									// }
									pageSize={size}
									onPageSizeChange={(newPageSize) => setSize(newPageSize)}
									rowsPerPageOptions={[5, 10, 20, 50, 100, 500, 1000]}
									pagination
									autoHeight={false}
									// autoHeight={isLgUp ? true : false}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									components={{
										LoadingOverlay: LinearProgress,
									}}
									// isRowSelectable={(params) =>
									// 	params.row.StateCategory === '완료' ? true : false
									// }
									loading={gridIsLoading}
									getRowHeight={() => 'auto'}
									getEstimatedRowHeight={() => 80}
									selectionModel={selectionModel}
									onSelectionModelChange={(newSelection) => {
										// console.log(pdfLimit)
										// if (pdfLimit >= newSelection.length) {
										// 	setSelectionModel(newSelection)
										// }
										setSelectionModel(newSelection)
									}}
									isCellEditable={isCellEditable}
									onCellEditCommit={handleCellEditCommit}
									density={(env.desnse as GridDensity) || 'compact'}
									checkboxSelection
									sx={{
										'& .MuiDataGrid-columnHeaderTitleContainer': {
											fontSize: '13px',
										},
										'& .MuiDataGrid-row.no-image-row:hover': {
											backgroundColor:
												theme.palette.mode === 'dark'
													? 'rgba(50, 48, 54, 1) !important'
													: '#fff !important',
										},
										'& .MuiDataGrid-row:hover': {
											backgroundColor: 'rgba(0,0,0, 0.1) !important',
										},
										'& .Mui-selected:hover': {
											backgroundColor: 'rgba(75, 123, 236, 0.08) !important',
										},
										'& .MuiDataGrid-cell': {
											fontSize: '13px !important',
											borderRight:
												theme.palette.mode === 'dark'
													? '1px solid rgba(81, 81, 81, 1)'
													: '1px solid rgba(224, 224, 224, 1)',
										},
										'& .Mui-disabled': {
											color: 'rgba(0, 0, 0, 0.1) !important',
										},
									}}
									disableMultipleSelection={false}
									initialState={{
										columns: {
											columnVisibilityModel,
										},
									}}
									onColumnVisibilityModelChange={(newModel) => {
										console.log(newModel)
										setColumnVisibilityModel(newModel)
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
					{/* <Grid
						item
						xs={5}
					>
						<PageBg style={{ marginTop: '1rem' }}>
							<Typography
								variant="subtitle1"
								component="h3"
								sx={{ lineHeight: '1rem', mb: 2 }}
							>
								메시지 전송
							</Typography>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={8}
								>
									<TextField
										multiline
										rows={20}
										fullWidth
										inputRef={messageInputRef}
										value={concatenatedMessage}
										onChange={(e) => {
											setConcatenatedMessage(e.target.value)
											updateMessageCursor(e.target)
										}}
										onClick={(e) => updateMessageCursor(e.target as HTMLTextAreaElement)}
										onKeyUp={(e) => updateMessageCursor(e.target as HTMLTextAreaElement)}
										onSelect={(e) => updateMessageCursor(e.target as HTMLTextAreaElement)}
									/>
									<Typography
										variant="caption"
										display="block"
										gutterBottom
										sx={{ mt: 0.5 }}
									>
										<b>{new Blob([concatenatedMessage]).size} Bytes</b>
									</Typography>
								</Grid>
								<Grid
									item
									xs={4}
								>
									<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
										{messageVariableList &&
											messageVariableList.length > 0 &&
											messageVariableList.map((item: any) => (
												<li key={item.id}>
													<Button
														type="button"
														variant="outlined"
														size="small"
														fullWidth
														sx={{ textAlign: 'left', mb: 0.5, display: 'block' }}
														onMouseDown={(e) => e.preventDefault()}
														onClick={() => insertMessageVariable(item.name)}
													>
														{item.name}
													</Button>
												</li>
											))}
									</ul>
								</Grid>
								<Grid
									item
									xs={12}
								>
									<TextField
										label="받는번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
									/>
									<TextField
										label="보내는번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										sx={{ my: 1 }}
									/>
									<Button
										color="secondary"
										variant="contained"
										startIcon={<SmsIcon />}
										sx={{ marginRight: '0.5rem' }}
										onClick={smsAction}
										fullWidth
										// disabled={isRptType0 ? true : false}
									>
										SMS 전송
									</Button>
								</Grid>
							</Grid>
						</PageBg>
					</Grid> */}
				</Grid>
			</Paper>
		</>
	)
}

export default AutoSmsIndivisual
